import { render, staticRenderFns } from "./Fps_chart.vue?vue&type=template&id=64e68afe"
import script from "./Fps_chart.vue?vue&type=script&setup=true&lang=js"
export * from "./Fps_chart.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Fps_chart.vue?vue&type=style&index=0&id=64e68afe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports